<template>
  <div class="main-content">
    <!-- Page Header Start --> 
    <PageHeader
      :pageHeaderBackgroundImageSrc="item?.article?.largeImageURL"
      :hasOverlay="true"
      :headerBackgroundOpacity="0.7"
    >
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="item?.article?.title"
        />
        <div style="min-width: 400px; width: 500px;" class="d-flex justify-content-center mt-3">
          <div class="w-100 d-flex flex-column flex-md-row flex-lg-row flex-xl-row align-items-center justify-content-center justify-content-md-between justify-content-lg-between justify-content-xl-between">
            <router-link
              class="mb-2 mb-md-0 mb-lg-0 mb-xl-0 mr-md-2 mr-lg-3 mr-xl-3"
              v-if="newsPage"
              :to="{
                name: String(isRecentNews) == 'true' ? 'news' : 'newsArchives', 
                query: {
                  newsPage, 
                  query,
                },
              }"
            >
              <v-btn
                rounded
                large
                dark
                :color="'#424EC4'"
              >
                {{ String(isRecentNews) == 'true' ? "Read All Recent News" : "Read All News Archive" }}
              </v-btn>
            </router-link>
            <router-link
              class="mb-2 mb-md-0 mb-lg-0 mb-xl-0 mr-md-2 mr-lg-3 mr-xl-3"
              v-else
              :to="{
                name: 'cybercorner',
              }"
            >
              <v-btn
                rounded
                large
                dark
                :color="'#424EC4'"
              >
                Back to Cyber Corner
              </v-btn>
            </router-link>
            <a
              class="mt-2 mt-md-0 mt-lg-0 mt-xl-0 ml-md-2 ml-lg-3 ml-xl-3"
              :href="isUrlValid(item?.article?.detailsURL) ? item?.article?.detailsURL : '/#/'"
              variant="link"
              target="_blank"
            >
              <v-btn
                rounded
                large
                dark
                :color="'#424EC4'"
              >
                Go To Article Source
              </v-btn>
            </a>
          </div>
        </div>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
         <!-- Login Modal for Like-->
    <b-modal size="lg" ref="my-like-modal" hide-footer centered title="Want to Like this post?">
      <p class="my-1">
        Please
        <router-link :to="{
        name: 'login', query: { redirect: this.$route.path, queryString: this.queryString, queryValue: this.queryValue }
      }">
          <a>LOGIN</a>
        </router-link>
        or
        <router-link :to="{ name: 'signup' }">
          <a>SIGN UP</a>
        </router-link>
        to like content.
      </p>
    </b-modal>
    <!-- End Login Modal -->
     <!-- Login Modal for Bookmark-->
    <b-modal size="lg" ref="my-modal" hide-footer centered title="Want to bookmark this for later?">
      <p class="my-4">
        Please
        <router-link :to="{
          name: 'login',
          query: { 
            redirect: this.$route.path, 
            queryString: this.queryString, 
            queryValue: this.queryValue 
          }
        }">
          <a>LOGIN</a>
        </router-link>
        or
        <router-link :to="{ name: 'signup' }">
          <a>SIGN UP</a>
        </router-link>
        to bookmark content.
      </p>
    </b-modal>    
    <!-- Start Top Social Media -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'blogs-top'"
      :isSocialMediaSiblingsVisible="true"
    >
      <div class="col-3 p-0 d-flex align-items-center">
        <p class="post-snippet text-start text-md-left text-lg-left text-xl-left">{{ getFormattedDate(item?.article?.date) }}</p>
      </div>
    </SocialMediaWidgets>
    <!-- End Top Social Media -->

    <!-- News Article Details Start -->
    <section class="section-content">
      <div class="container my-3 px-3 px-md-0 px-lg-0 px-xl-0">
        <!---------- NEWS ARTICLE HEADLINE ----------->
        <p class="mb-3">
          <strong>{{item?.article?.headLine}}</strong>
        </p>

        <!---------- NEWS ARTICLE SUMMARY ------------>
        <span id="article-summary" v-html="item?.article?.summary">
        </span>
      </div>
      </section>
        <!-- Start Bottom Social Media -->
   
        <SocialMediaWidgets
          :title="title"
          :description="description"
          :type="'blogs-bottom'"
          :isSocialMediaSiblingsVisible="true"
          :hasBottomMargin="true"
          :socialShareColumnClass="'col-12'"
          :socialShareFlexJustifyClass="socialMediaFlexJustify"
        >
          <div class="col-12 col-lg-9 col-xl-9 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start">
            <div :style="{ 'width': bottomRowLikesBookmarksWidth }" class="d-flex flex-row justify-content-between">
              <div class="mr-4" v-on:click="initiateLike()">
                <FlatIconButton label="Like" icon="mdi mdi-thumb-up-outline" v-if="this.liked === false" />
                <FlatIconButton label="Liked" icon="mdi mdi-thumb-up" v-if="this.liked === true" />
              </div>
              <p class="social-button-area-left-text">
                <span class="mr-4">{{ likeText }}</span>
                <!-- <span class="mr-4">|</span>
                <span>0 Shares</span> -->
              </p>
              <div class="pl-1 bookmark-page" v-if="!isPageBookmarked" v-on:click="onBookmarkPage">
                <div id="tooltip-bookmark">
                  <font-awesome-icon :icon="['far', 'bookmark']"/>
                  Bookmark
                </div>
                <b-tooltip variant="primary" target="tooltip-bookmark">Click to bookmark page</b-tooltip>
              </div>
              <!-- Page Already Bookmarked -->
              <div class="pl-1 bookmark-page" v-else v-on:click="onBookmarkPage">
                <font-awesome-icon id="tooltip-bookmark" :icon="['fas', 'bookmark']"/>
                Bookmarked
                <b-tooltip variant="success" target="tooltip-bookmark">Bookmarked!</b-tooltip>
              </div>
            </div>
          </div>
        </SocialMediaWidgets>
    <!-- End Bottom Social Media -->
    <section class="section-content">
      <div class="container mb-5 my-3 px-3 px-md-0 px-lg-0 px-xl-0">

        <!------- PREVIOUS & NEXT NEWS BUTTONS ------->
        <div class="row m-0 mt-4">
          <div class="col-12 col-md-6 col-lg-6 col-xl-6 p-0 mb-2 mb-md-0 mb-lg-0 mb-xl-0 d-flex justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start">
            <v-btn 
              v-if="previousNewsItemId"
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(previousNewsItemId, '#/newsdetail')"
            >
              Read Previous Article
            </v-btn>
          </div>
          <div class="col-12 col-md-6 col-lg-6 col-xl-6 p-0 mt-2 mt-md-0 mt-lg-0 mt-xl-0 d-flex justify-content-center justify-content-md-end justify-content-lg-end justify-content-xl-end">
            <v-btn
              v-if="nextNewsItemId"
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(nextNewsItemId, '#/newsdetail')"
            >
              Read Next Article
            </v-btn>
          </div>
        </div>
      </div>
    </section>
    <!-- News Article Details End -->
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import moment from 'moment';
import axios from 'axios';
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from './library/widgets/title-text-content.vue';
import SocialMediaWidgets from './library/widgets/social-media-widgets.vue';
import { EventBus } from '../utils/eventBus';
import { isLoggedIn, handleApiError } from '../utils/authentication';
import FlatIconButton from './library/buttons/flat-icon-button';

export default {
  name: 'newsdetail',
  components: {
    BFormInput,
		PageHeader,
		PageHeaderTitleContent,
    TitleTextContent,
    SocialMediaWidgets,
    FlatIconButton
  },
  props: {
    id: String,
    newsPage: String,
    query: String,
    isRecentNews: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      item: {},
      isPageBookmarked: false,
      isPageBookmarkedId: null,
      liked: false,
      likeId: null,
      numOfLikes: 0,
      queryValue: this.id,
      queryString: "id",
      categories: [
        { name: 'Cyber Security', articles: 4 },
        { name: 'Software', articles: 5 },
        { name: 'Manufacturing', articles: 6 },
        { name: 'Learning Tools', articles: 7 },
      ],
      archives: [
        { name: 'February 2020', articles: 4 },
        { name: 'January 2020', articles: 5 },
        { name: 'June 2020', articles: 6 },
        { name: 'May 2020', articles: 7 },
      ],
      tags: [
        { name: 'Development' },
        { name: 'Security' },
        { name: 'Infrastructure' },
        { name: 'Androids' },
        { name: 'Phishing' },
        { name: 'Coronavirus' },
      ],
      linkCopyText: 'Click to copy url link',
      previousNewsItemId: null,
      nextNewsItemId: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    likeText() {
      return `${this.numOfLikes} ${this.numOfLikes === 1 ? 'Like' : 'Likes'}`;
    },
    url() {
      return window.location.hash || 'URL';
    },
    title() {
      return this.item?.article?.title || 'Title';
    },
    description() {
      return this.item?.article?.headLine || 'HeadLine';
    },
    bottomRowLikesBookmarksWidth() {
      return this.isMobile || this.$vuetify.breakpoint.md ? '90%' : '30%';
    },
    socialMediaFlexJustify() {
    return this.isMobile || this.$vuetify.breakpoint.md ? 'justify-content-center' : 'justify-content-end';
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
  },
  methods: {
    init() {
      EventBus.$emit("activate-indicated-menu-item", "Cyber Corner");
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
      onBookmarkPage() {
      if (!isLoggedIn()) {
        this.$refs['my-modal'].show();
      } else {
        this.bookmarkPage();
      }
    },

    async bookmarkPage() {
      if (this.isPageBookmarkedId == null) {
        axios
          .post('/api/bookmark', {
            url: this.url,
            title: this.title,
            type: 'news',
          })
          .then((response) => {
            this.isPageBookmarked = response.data.isPageBookmarked;
            this.isPageBookmarkedId = response.data.id;
          })
          .catch((error) => {
            handleApiError(error, this.$router);
          });
      } else {
        axios
          .delete("/api/bookmark/" + this.isPageBookmarkedId)
          .then((response) => {
            this.isPageBookmarked = false;
            this.isPageBookmarkedId = null;
          })
          .catch((error) => {
            handleApiError(error, this.$router);
          });
      }
    },

    async checkIfBookmarked() {
    axios
      .post('/api/bookmark/isBookmarked', {
        url: this.url
      })
      .then((response) => {
        this.isPageBookmarked = response.data.isPageBookmarked;
        this.isPageBookmarkedId = response.data.id ? response.data.id : null;
      })
      .catch((error) => {
        handleApiError(error, this.$router);
      });
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    isUrlValid(urlString) {
      try {
        new URL(urlString);
        return true;
      }
      catch {
        return false;
      }
    },
    initiateLike() {
      if (!isLoggedIn()) {
        console.warn('Not Logged In');
        this.$refs['my-like-modal'].show();
      } else {
        this.toggleLike();
      }
    },
    toggleLike() {
      if (this.liked) {
        this.unlikeBlog()
      } else {
        this.likeBlog()
      }
    },
    likeBlog() {
      this.liked = true;
      const id = String(this.id);
      axios.post('/api/likes', { blogId: id }).then((resp) => {
        if (resp.data) {
          this.likeId = resp.data;
          this.liked = true;
          this.numOfLikes++;
        } else {
          console.error("Like action failed:", resp.data);
        }

      });
    },

    unlikeBlog() {
      this.liked = false;
      axios.delete('/api/likes/' + this.likeId).then((resp) => {
        this.liked = false;
        this.numOfLikes--;
      });
    },
    loadLikeNum(id) {
      axios.get('/api/likes/num/' + id).then((resp) => {
        
        this.numOfLikes = resp.data.numOfLikes || 0;
      });
    },
    loadLike(id) {      
      axios.get('/api/likes/' + id).then((resp) => {
        this.likeId = resp.data.likeId || null;
        if (this.likeId != null) {
          this.liked = true;
        }
      });
    },
    async getResource(id) {
      const today = moment().valueOf();
      const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();

      const newsItems = this.isRecentNews.toString() === 'true' 
                          ? this.$store.state.newsItems.filter(({ date }) => (moment(date).valueOf() > fromTheLastSixMonths) && (moment(date).valueOf() < today)) 
                          : this.$store.state.newsItems.filter(({ date }) => moment(date).valueOf() < fromTheLastSixMonths);

      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/news/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            this.item = response.data.Items[0];
            const currentNewsItemIndex = newsItems.findIndex(({ id }) => id === this.item.id);
            //console.log(response.data);

            // The previous news article id
            this.previousNewsItemId = newsItems[currentNewsItemIndex - 1]?.id;

            // The next news article id
            this.nextNewsItemId = newsItems[currentNewsItemIndex + 1]?.id;
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'news' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'news' });
        })
        .finally(() => {
          /*** THIS IMPLEMENTATION REMOVES THE EMPTY P ELEMENTS AT THE END OF THE ARTICLE THAT APPEARS AS WHITE SPACE ***/
          const articleSummaryEl = document.getElementById('article-summary');
          const allEmptyParagraphs = Array
                                      .from(articleSummaryEl.querySelectorAll('p'))
                                      .filter((p) => p.textContent.trim() === '');
          for(let i=0; i<allEmptyParagraphs.length; i++) {
            const p = allEmptyParagraphs[i];
            p.remove();
          }
        });
        /****************************************************************************************************************/
    },
  },
  async created() {
    if (this.id) {
      await this.getResource(this.id);
      if (isLoggedIn()) {
        this.checkIfBookmarked();
        this.loadLike(this.id);
        this.loadLikeNum(this.id);
      }
    } else {
      this.$router.push({ path: 'news' });
    }
  }
};
</script> 
<style scoped>
.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

section ::v-deep a {
  word-break: break-all;
}
.bookmark-page:hover {
  cursor: pointer;
  opacity: .66;
}

.bookmark-page {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #424242;
  font-size: 14px;
}

#tooltip-bookmark {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
